// Libs
import styled, { css } from 'styled-components'

// Comps
import { colors } from '../utils'
import { forScreensGreaterThanMobileWidth, mobileScreen } from '../utils'

export const howItWorkStyles = css`
  .container {
    width: 100%;
    max-width: 82%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    margin: auto;
    
    ${forScreensGreaterThanMobileWidth(css`
      flex-direction: row;
      align-items: flex-start;
    `)}
  }


  .hiwItem {

    width: 100%;
    
    &:not(:first-of-type) { margin-top: 30px; }

    ${forScreensGreaterThanMobileWidth(css`
      width: 322px;
      max-width: calc(100% / 3);
      &:not(:first-of-type) {
        margin-top: 0;
      }
    `)}

  }
  
  .hiwItem + .hiwItem {
    ${forScreensGreaterThanMobileWidth(css`
      margin-left: 29px;
    `)}
  }

  .section {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    ${forScreensGreaterThanMobileWidth(css`
      justify-content: space-between;
    `)}
  }

  .section + .section {
    margin-top: 20px;
  }

  .numberContainer {
    flex-shrink: 0;
    border-radius: 60px;
    height: 60px;
    width: 60px;
    background: ${colors.backgroundWhite};
    margin-right: 15px;
    display:flex;
    flex-direction: column;
    justify-content: center;
    margin-right: 25px;
    align-self: center;

    ${forScreensGreaterThanMobileWidth(css`
      flex-shrink: 0;
    `)}

    &.hide {
      background: transparent;
    }

    .number {
      color: ${colors.purple};
      width:12px;
      height: 29px;
      text-align:center;
      margin: auto;
    }
  }

  .titleContainer {
    display:flex;
    min-height: 52px;
    width: 100%;
    
    ${mobileScreen(css`
      width: unset;
      justify-content: center;
      align-items: center;
    `)}

  .title {
    ${mobileScreen(css`
      width: 240px;
    `)}
  }

  .content {
  
    font-size: 14px;
    line-height: 140%;
    letter-spacing: -0.5px;
    opacity: 0.8;

    ${mobileScreen(css`
      width: 240px;
    `)}
  }
`
